import AppRoutes from '@/routes';

/**
 * Componente principal de la aplicación
 * Configura el sistema de rutas y navegación
 */
function App() {
  return <AppRoutes />;
}

export default App;



